import { render, staticRenderFns } from "./AdminUpdateVideoContent.vue?vue&type=template&id=81ec8f68&scoped=true"
import script from "./AdminUpdateVideoContent.vue?vue&type=script&lang=js"
export * from "./AdminUpdateVideoContent.vue?vue&type=script&lang=js"
import style0 from "./AdminUpdateVideoContent.vue?vue&type=style&index=0&id=81ec8f68&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ec8f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81ec8f68')) {
      api.createRecord('81ec8f68', component.options)
    } else {
      api.reload('81ec8f68', component.options)
    }
    module.hot.accept("./AdminUpdateVideoContent.vue?vue&type=template&id=81ec8f68&scoped=true", function () {
      api.rerender('81ec8f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminUpdateVideoContent.vue"
export default component.exports